var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.198,
    height: 23.542,
    viewBox: "0 0 22.198 23.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 22.198,
    height: 23.542,
    fill: "#d51a66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M.077,11.629A1.276,1.276,0,0,0,.832,12.8L8.8,15.775l.295,6.772a.665.665,0,0,0,.368.592.416.416,0,0,0,.177.038.506.506,0,0,0,.41-.224l2.817-3.846,3.993,3.406a.924.924,0,0,0,.6.236A1.156,1.156,0,0,0,18.507,21.7L21.822.876a.765.765,0,0,0-.186-.648.468.468,0,0,0-.551-.1L.714,10.344a1.376,1.376,0,0,0-.637,1.285m10.028,9.238L9.923,16.6l2.042,1.739Zm7.34.522-7.27-6.2L20.372,3.03ZM19.252,2.493,9.174,14.51,1.212,11.546Z",
    transform: "translate(0.147 0.147)",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M.077,11.629A1.276,1.276,0,0,0,.832,12.8L8.8,15.775l.295,6.772a.665.665,0,0,0,.368.592.416.416,0,0,0,.177.038.506.506,0,0,0,.41-.224l2.817-3.846,3.993,3.406a.924.924,0,0,0,.6.236A1.156,1.156,0,0,0,18.507,21.7L21.822.876a.765.765,0,0,0-.186-.648.468.468,0,0,0-.551-.1L.714,10.344A1.376,1.376,0,0,0,.077,11.629Zm10.028,9.238L9.923,16.6l2.042,1.739Zm7.34.522-7.27-6.2L20.372,3.03ZM19.252,2.493,9.174,14.51,1.212,11.546Z",
    transform: "translate(0.147 0.147)",
    fill: "#d51a66",
    stroke: "#575454",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.52bdd7f50c4f7f148d70bf67c1d3a683.svg";
export { ForwardRef as ReactComponent };